import { h } from 'preact';
import { useMemo, useState, useEffect } from 'preact/hooks';
import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import { formatVariantMedia } from 'utils/storefront/format-resource';
import useResponsive from 'utils/responsive';
import ProductGalleryMobile from './product-gallery-mobile';
import ProductGalleryDesktop from './product-gallery-desktop';

const ProductGallery = ({isProductQuickView = false, ...props}) => { 
  const { isMobile } = useResponsive();
  const [product, setProduct] = useState(props.product);

  const storefront = Storefront.getInstance();
  const getVariantMedia = async (id) => {
    const response = await storefront.request({
      query: queries.variantsMediaById,
      variables: {
        ids: [id]
      },
    });

    if (response.errors) {
      // eslint-disable-next-line no-console
      console.error(response.errors);
      return {};
    }
    if (!response.data.nodes[0].description) return false;

    return formatVariantMedia(
      response.data.nodes[0].description.references.edges
    );
  };

  const handleCurrentVariantUpdated = (e) => {
    getVariantMedia(e.detail.currentVariant).then((productMedia) => {
      if(productMedia){
        setProduct({
          ...product,
          media: productMedia,
        });
      } else {
        setProduct({
          product: e.detail.currentProductData,
          media: e.detail.currentProductData?.media,
        })
      }
    });
  };

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => document.removeEventListener('currentVariantUpdated', handleCurrentVariantUpdated);
  }, []);

  if (!isMobile && !isProductQuickView) {
    return useMemo(
      () => <ProductGalleryDesktop {...props} currentProduct={product} />,
      [product, isMobile],
    );
  }

  return useMemo(
    () => <ProductGalleryMobile {...props} currentProduct={product} />,
    [product, isMobile],
  );
};

export default ProductGallery;
